module.exports = require('./dist-modules/utils/prop-types.js').default;
